"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkEntityTypeUrl = void 0;
exports.linkEntityTypeUrl = "https://blockprotocol.org/@blockprotocol/types/entity-type/link/v/1";
